module.exports = __webpack_public_path__ + "static/media/55.a3ee7e43.png";